<template>
  <header class="business-hours-header">
    <h2>Horário de funcionamento</h2>
  </header>
</template>
<script>
export default {
  components: {},

  data() {
    return {};
  },

  methods: {},

  computed: {},
};
</script>

<style lang="scss" scoped>
.business-hours-header {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
